"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const BlockText = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement("rect", { width: 24, height: 18, y: 3, fill: "#8790A6", className: styles.accentColor, rx: 2 }),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M14.667 9.333a.667.667 0 1 0 0 1.334H20a.667.667 0 0 0 0-1.334zm0 3.334a.667.667 0 0 0 0 1.333H20a.667.667 0 0 0 0-1.333z",
        opacity: 0.6
      }
    ),
    /* @__PURE__ */ React.createElement("path", { stroke: "#fff", d: "M4 10.667v-2h3.333m3.334 2v-2H7.333m0 0v6.666m-2 0h4" })
  );
};
export default BlockText;
